<div #trigger>
  <ng-content select="[trigger]"></ng-content>
</div>
@if (isVisible) {
  <div #popup [class]="'box ' + positionClass" [class.wide]="wide()">
    <ng-content select="[content]"></ng-content>
  </div>
}
